const actions = {

  MEMBERS_READ_BEGIN: 'MEMBERS_READ_BEGIN',
  MEMBERS_READ_SUCCESS: 'MEMBERS_READ_SUCCESS',
  MEMBERS_READ_ERR: 'MEMBERS_READ_ERR',

  MEMBER_ADD_BEGIN: 'MEMBER_ADD_BEGIN',
  MEMBER_ADD_SUCCESS: 'MEMBER_ADD_SUCCESS',
  MEMBER_ADD_ERR: 'MEMBER_ADD_ERR',

  MEMBER_UPDATE_BEGIN: 'MEMBER_UPDATE_BEGIN',
  MEMBER_UPDATE_SUCCESS: 'MEMBER_UPDATE_SUCCESS',
  MEMBER_UPDATE_ERR: 'MEMBER_UPDATE_ERR',

  MEMBER_DELETE_BEGIN: 'MEMBER_DELETE_BEGIN',
  MEMBER_DELETE_SUCCESS: 'MEMBER_DELETE_SUCCESS',
  MEMBER_DELETE_ERR: 'MEMBER_DELETE_ERR',

  MEMBER_READ_BEGIN: 'MEMBER_READ_BEGIN',
  MEMBER_READ_SUCCESS: 'MEMBER_READ_SUCCESS',
  MEMBER_READ_ERR: 'MEMBER_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.MEMBERS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.MEMBERS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.MEMBERS_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.MEMBER_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.MEMBER_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.MEMBER_ADD_ERR,
      err,
    };
  },

  axiosUpdateBegin: () => {
    return {
      type: actions.MEMBER_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.MEMBER_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.MEMBER_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.MEMBER_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.MEMBER_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.MEMBER_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.MEMBER_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.MEMBER_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.MEMBER_READ_ERR,
      err,
    };
  },

};

export default actions;
